const React = require('react');
const { useState } = React;
const Dialog = require('./Dialog');
const { default: DialogContentText } = require('@mui/material/DialogContentText');
const { default: Styled } = require('styled-components');
const Ui = require('./styles');

const internals = {};

module.exports = function DiscoverControls({ enabled, showBoard, onToggle, period, onPeriodChange, normalControls, roleLabel = 'Students' }) {

    const [helpOpen, setHelpOpen] = useState(false);
    const { Row, Toggle, Fields, Field, Info, ToggleGroup } = internals;

    if (!enabled) {
        return normalControls || null;
    }

    return <Row>
        <ToggleGroup><Toggle><input type='checkbox' checked={showBoard} onChange={(event) => onToggle(event.target.checked)} />Leaderboard</Toggle><Info aria-label='About the leaderboard' onClick={() => setHelpOpen(true)}>i</Info></ToggleGroup>
        <Dialog open={helpOpen} onClose={() => setHelpOpen(false)} title='Leaderboard' closeLabel='Close leaderboard help' descriptionId='leaderboard-help-description'>
            <DialogContentText id='leaderboard-help-description'>The leaderboard ranks members of your community by points earned this week or all time. Earn points by connecting with classmates, chatting, joining groups, adding interests and passions, completing surveys, and participating daily.</DialogContentText>
        </Dialog>
        {normalControls || (showBoard ? <Fields>
            <Field>Show By<select aria-label='Show By' value={period} onChange={(event) => onPeriodChange(event.target.value)}><option value='weekly'>This week</option><option value='allTime'>All time</option></select></Field>
            <Field>Role<select aria-label='Role' value='student' onChange={() => {}}><option value='student'>{roleLabel}</option></select></Field>
        </Fields> : null)}
    </Row>;
};

internals.Row = Styled.div`${Ui.body} display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px; width: 100%; max-width: 560px; min-width: 0; form { width: 100%; min-width: 0; }`;
internals.Toggle = Styled.label`display: flex; align-items: center; gap: 5px; flex: 0 0 auto; font-size: 14px; cursor: pointer; input { margin: 0; cursor: pointer; }`;
internals.Fields = Styled.div`display: flex; gap: 12px; width: 100%; min-width: 0;`;
internals.Field = Styled.label`display: flex; flex-direction: column; gap: 4px; flex: 1; min-width: 0; padding: 8px 12px; border-radius: 12px; background: ${Ui.hover}; color: ${Ui.text}; font-size: 13px; select { width: 100%; min-width: 0; border: 0; background: transparent; color: inherit; font-size: 15px; cursor: pointer; }`;

internals.ToggleGroup = Styled.div`display: flex; align-items: center; gap: 5px; flex: 0 0 auto;`;
internals.Info = Styled.button`border: 1px solid currentColor; border-radius: 50%; width: 18px; height: 18px; padding: 0; background: transparent; color: ${Ui.secondaryText}; font: inherit; font-size: 12px; font-weight: 700; cursor: pointer;`;
